/* eslint-disable sciencepo-rules/require-story*/
/* Inutile de le tester ce n'est pas un composant react*/

const isEcoWebInlineImage = (domNode) => {
  return domNode.attribs && domNode.attribs['data-gatsby-image-wrapper'] !== undefined;
};

const isAccordeonDomNode = (domNode) => {
  return domNode.attribs && domNode.attribs.class === 'accordeon';
};

const isScript = (domNode) => {
  return domNode.name === 'script';
};

const isShowMoreDomNode = (domNode) => {
  return domNode.name === 'more';
};

const isLinkBoxSticky = (domNode) => {
  return domNode.attribs && domNode.attribs.class === 'linkBoxSticky';
};

const isAuthorQuote = (domNode) => {
  return domNode.attribs && domNode.attribs.class === 'author-quote';
};

const nodeToEcoWebInlineImage = (domNode) => {
  if (domNode.children) {
    domNode.children.forEach((n, idx) => {
      if (idx === 1) {
        n.attribs.style = 'height: 100%; left: 0px; position: absolute; top: 0px; width: 100%; opacity: 0;';
      } else if (idx === 2) {
        n.attribs.style =
          'height: 100%;\
          left: 0px;\
          position: absolute;\
          top: 0px;\
          transform: translateZ(0px);\
          transition: opacity 250ms linear 0s;\
          width: 100%;\
          will-change: opacity;\
          opacity: 1;\
          ';
      }
    });
  }

  return domNode;
};

module.exports = {
  isAuthorQuote,
  isAccordeonDomNode,
  isLinkBoxSticky,
  isScript,
  isEcoWebInlineImage,
  nodeToEcoWebInlineImage,
  isShowMoreDomNode,
};
